import { env } from "@/env";

export const APP_URL = env.NEXT_PUBLIC_BASE_URL;

export const timeZone = "Asia/Kolkata"; // Your desired timezone

export const SESSION_NAME = "sessionToken";

export const LOGO = "/assets/logo.webp";
export const LOGO_BLACK = "/assets/logo-black.webp";
export const SINGUP_IMAGE = "/assets/login-img.webp";
export const HERO_IMAGE = "/assets/hero-img.webp";
export const AVATAR_PLACEHOLDER = "/assets/avatar-placeholder.webp";
export const DEFAULT_IMAGE = "/assets/icon.webp";
export const BANNER_IMAGE_2 = "/assets/banner-img-2.webp";
export const WHY_CHOOSE_US = "/assets/why-choose-us-img.webp";
export const TESTIMONIAL_BG = "/assets/testimonial-bg.webp";
export const FOOTER_BG = "/assets/footer-bg.webp";
export const DESTINATION_BG = "/assets/destination-bg.webp";
export const ERROR_IMAGE = "/assets/error-img.webp";
export const ABOUT_BG = "/assets/about-bg.jpg";
export const OUR_MISSION = "/assets/our-mission.webp";
export const OUR_VISION = "/assets/our-vision.webp";
export const TEAM_IMG_1 = "/assets/team-img-1.webp";
export const TEAM_IMG_2 = "/assets/team-img-2.webp";
export const BLOG_BG = "/assets/blog-bg.webp";
export const MAP_OUTLINE = "/assets/map-outline.webp";
export const GET_IN_TOUCH = "/assets/get-in-touch-illustration.png";
export const IMAGE_404 = "/assets/404.png";
export const UPCOMING_TRIPS_BG = "/assets/upcoming-trips.webp";
export const UPCOMING_TREKS_BG = "/assets/upcoming-treks.webp";